export const BNK_STMT_updateShowBSWelcomeScreenReducer = {
  BNK_STMT_updateShowBSWelcomeScreen: (state, action) => {
    state.showBSWelcomeScreen = action.payload;
  },
};
